import Button from '@components/button/Button';
import { Tab } from './EditActivityCombined';

interface EditHeaderButtonsProps {
  handleTabChange: (tab: Tab) => void;
  tab: Tab;
}

const EditHeaderButtons = ({ handleTabChange, tab }: EditHeaderButtonsProps) => {
  return (
    <div className="edit-activity-tabs">
      <Button
        onClick={() => handleTabChange(Tab.Activity)}
        className={`btn ${tab === Tab.Activity ? 'active' : ''}`}
      >
        Activity
      </Button>
      <Button
        onClick={() => handleTabChange(Tab.Modules)}
        className={`btn ${tab === Tab.Modules ? 'active' : ''}`}
      >
        Modules
      </Button>
    </div>
  )
}

export default EditHeaderButtons